module.exports = __webpack_public_path__ + "img/icon-indices-tematicos.6e26ff12.svg";